import * as types from './mutation-types'
import {
    proxy
} from '../utils/storageProxy/LSProxy'

const mutations = {
    [types.SET_QUOTATION](state, quotation) {
        state.quotation = quotation
        proxy(state, 'list', ['quotation'])
    },
    SAVE_HEADER_FORM(state, val) {
        state.headerForm = val
    },
    SAVE_BASE_FORM(state, val) {
        state.baseForm = val
    },
    save_legalInfoForm(state, val) {
        state.legalInfoForm = val
    },
    save_gnForm(state, val) {
        state.gnForm = val
    },
    save_gatForm(state, val) {
        state.gatForm = val
    },
    save_gn_contactForm(state, val) {
        state.gn_contactForm = val
    },
    save_gat_contactForm(state, val) {
        state.gat_contactForm = val
    },
    save_storeForm(state, val) {
        state.storeForm = val
    },
    save_ruleFrom(state, val) {
        state.ruleFrom = val
    },
    save_companyBusinessForm(state, val) {
        state.companyBusinessForm = val
    },
    save_cooperativeForm(state, val) {
        state.cooperativeForm = val
    },
    save_checkedObj(state, val) {
        state.checkedObj = val
    },
    save_maintypeArr(state, val) {
        state.maintypeArr = val
    },
    /** 规格属性 */
    save_normalObj(state, val) {
        state.normalObj = val
    },
    save_attrArr(state, val) {
        state.attrArr = val
    },
    //类目
    save_typeStr(state, val) {
        state.typeStr = val
    },
    save_typeName(state, val) {
        state.typeName = val
    },
    save_typeRule(state, val) {
        state.typeRuleArr = val
    },
    save_backgroundStr(state, val) {
        state.backgroundStr = val
    },
    //
    save_skuList(state, val) {
        state.skuList = val
    },
    // 用于yunji-components AttractFooter 组件左侧宽度计算
    LayoutGrid(state, value) {
        // 设置左侧siderBar是否可见
        state.layoutGrid = value
    },
    // 活动函id方法
    setPromotionId(state, params) {
        state.promotionId = params
    },
    // 活动函状态方法
    setPromotionStatus(state, params) {
        state.promotionStatus = params
    },
    //跨境pop提报
    // eslint-disable-next-line camelcase
    save_crossBorderForm(state, params) {
        state.crossBorderForm = params || {}
    }
}


export default mutations